import { makeStyles, TextField, MenuItem } from "@material-ui/core";
import TextInput from "../Inputs/TextInput";
import SButton from "../SButton/SButton";
import { XIcon } from "@phosphor-icons/react";

const useStyles = makeStyles({
    superSmallTextField: {
        "& .MuiOutlinedInput-input": {
            padding: "0.6rem 1rem",
            fontSize: "0.8rem",
        },
        "& .MuiInputLabel-outlined": {
            transform: "translate(14px, 10px) scale(1)",
            fontSize: "0.85rem",
        },
        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
            transform: "translate(16px, -5px) scale(0.75)",
        },
        "& fieldset legend": {
            fontSize: "0.8em",
        },
        '& .MuiSelect-select:focus': {
            backgroundColor: 'inherit'
        },
        // NEW: Ensure text doesn't slide under the clear icon + dropdown arrow
        '& .MuiSelect-select': {
            paddingRight: '60px !important'
        }
    }
});

const TableFilters = ({ filterConfig, value, setFilters }) => {

    const classes = useStyles();

    switch (filterConfig?.type) {
        case 'search':
            return (
                <TextField
                    variant="outlined"
                    name={filterConfig?.key}
                    label={filterConfig?.name}
                    value={value || ''}
                    onChange={(e) => {
                        const { value } = e?.target;
                        setFilters(prev => ({ ...prev, [filterConfig?.key]: value }))
                    }}
                    autoComplete="off"
                    size="small"
                    fullWidth
                    className={classes.superSmallTextField}
                    InputProps={{
                        endAdornment: (value ? <SButton size="medium" variant={"tertiary"} onClick={() => { setFilters(prev => ({ ...prev, [filterConfig?.key]: '' })) }} ><XIcon /></SButton> : undefined)
                    }}
                />
            );

        case 'select':
            return (
                // 1. Wrap in a relative container
                <div style={{ position: 'relative', width: '100%' }}>
                    <TextField
                        select
                        variant="outlined"
                        name={filterConfig?.key}
                        label={filterConfig?.name}
                        value={value?.id || ''}
                        onChange={(e) => {
                            const { value } = e?.target;
                            const toSetValue = filterConfig?.options?.find(o => o?.id === value)
                            setFilters(prev => ({ ...prev, [filterConfig?.key]: toSetValue }));
                        }}
                        size="small"
                        fullWidth
                        className={classes.superSmallTextField}
                        autoComplete="off"
                    // 2. We completely remove InputProps here!
                    >
                        {filterConfig?.options?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>

                    {/* 3. Render the button independently over the input */}
                    {value?.id && (
                        <SButton
                            variant={"tertiary"}
                            onMouseDown={(e) => e?.stopPropagation()}
                            onClick={(e) => {
                                e?.stopPropagation();
                                setFilters(prev => ({ ...prev, [filterConfig?.key]: null }))
                            }}
                            style={{
                                position: 'absolute',
                                right: '28px', // Positioned just to the left of the standard MUI down arrow
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 1, // Ensure it sits on top and is clickable
                                padding: '4px',
                                minWidth: 'auto'
                            }}
                        >
                            <XIcon size={16} />
                        </SButton>
                    )}
                </div>
            );
        default:
            return null;
    }
};

export default TableFilters;